const setMirchiMurgaList = data => ({
    type: "SET_MIRCHIMURGA_LIST",
    data
  });

  export const mutation = {
    setMirchiMurgaList
  };
  